import { Injectable } from '@angular/core';
import { ApiClient } from '../core/api-client.service';
import { Observable } from 'rxjs';
import { PendingLettersDtRetInfo } from './DTOs/pending-letters-dt-ret-info';
import { GetPendingLettersListRequest } from './DTOs/get-pending-letters-list-request';
import { VerifyRejectRequest } from '../core/verify-reject-request';
import { PendingLetterInfo } from './DTOs/pending-letter-info';
import { UpdateLetterRequest } from './DTOs/update-letter-request';
@Injectable({
  providedIn: 'root'
})
export class PendingLettersService {
    readonly relativeBase = "pending-letters/";

    constructor(private http: ApiClient) { }


    changeLetterStatus(request: VerifyRejectRequest, status: number) {
        if (status == 1) {
            return this.http.post(this.relativeBase + "approve", request);
        } else {
            return this.http.post(this.relativeBase + "reject", request);
        }
    }

    getPendingLetterInfo(id: number): Observable<PendingLetterInfo>{
        return this.http.get(this.relativeBase + "get-pending-letter-details/" + id);
    }

    getPendingLettersList(request: GetPendingLettersListRequest): Observable<PendingLettersDtRetInfo> {
        return this.http.post(this.relativeBase + "get-pending-letters", request);
    }

    updateLetter(request: UpdateLetterRequest) {
        return this.http.post(this.relativeBase + "update", request);
    }
}
